import {Nullish} from 'utility-types';

import {isNil} from 'ramda';

import {formatPercentage} from './formatPercentage';

export function formatFuelTank(value: number | Nullish) {
  if (isNil(value)) {
    return;
  }

  return formatPercentage(value);
}
